import {
    SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_REQUEST,
    SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_SUCCESS,
    SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_FAILURE,
    SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_REQUEST,
    SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_SUCCESS,
    SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_FAILURE
  } from "../types/sub-job-pending-receive-gray-report-types";
  
  const initialState = {
    subJobPendingReceiveGrayReports: {},
    loading: false,
    error: null,
  };
  
  const subJobPendingReceiveGrayReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_REQUEST, SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_SUCCESS: {
        return {
          ...state,
          subJobPendingStockReceiveGrayReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          subJobPendingStockReceiveGrayFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_FAILURE, SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default subJobPendingReceiveGrayReportReducer;
  